import { cva, type VariantProps } from 'class-variance-authority';
import { uiMarker, uiMarkerLayout } from './shared';

/**
 * STAT CARD
 *
 * One headline number on a card: a label, the figure, and how it moved.
 * The analytics page drew four of these by hand as a Card with a Stack in it;
 * the dashboard overviews want the same tile for calls, revenue and drivers.
 *
 * The delta's colour comes from whether the movement is *good*, not from
 * whether it went up — a bounce rate falling is the one an owner wants to
 * see, and painting it red because the arrow points down reads as a warning.
 * A movement with no good/bad reading stays muted rather than picking a side.
 */
export const statCardRecipe = cva([
  uiMarker,
  uiMarkerLayout,
  'flex flex-col gap-2',
]);

/** Colour only — the row itself is an Inline. */
export const statCardDeltaRecipe = cva([uiMarker], {
  variants: {
    trend: {
      good: 'text-success',
      bad: 'text-destructive',
      neutral: 'text-muted-foreground',
    },
  },
  defaultVariants: { trend: 'neutral' },
});

export type StatCardDeltaRecipeProps = VariantProps<typeof statCardDeltaRecipe>;
